import { render } from "./announceEdit.vue?vue&type=template&id=75bbe88d"
import script from "./announceEdit.vue?vue&type=script&lang=js"
export * from "./announceEdit.vue?vue&type=script&lang=js"

import "./announceEdit.vue?vue&type=style&index=0&id=75bbe88d&lang=scss"

import exportComponent from "../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__